export const CALENDAR_SETTINGS_TASK_TYPE_LABEL_SEPARATOR = ' · '
